import Cookies from 'js-cookie';

export async function CreateAsUserIfNotExist(token, body) {
  const response = await fetch('/createasuserifnotexist', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(body),
  });
  const data = await response.json();

  if (data === 'Unauthorized') {
    // alert('Your session is expired. You need to re-login.');
    Cookies.remove('user');
    window.location.reload();
  } else {
    return data;
  }
}

export function GetParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function GetCookie(name) {
  const sessionOverride = sessionStorage.getItem(name);
  if (sessionOverride !== null) return sessionOverride;
  return Cookies.get(name);
}

export function IsImpersonation() {
  return sessionStorage.getItem('isImpersonation') === 'true';
}

export function RemoveCookie(name) {
  sessionStorage.removeItem(name);
  return Cookies.remove(name);
}

export function Timeout(alertMessage) {
  if (alertMessage === 'Success') {
    return 1500;
  } else {
    return 4000;
  }
}

// change this url for the api example: https://api.eladb2.com
export function ApiDomainUrl() {
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
}

const BROWSER_PREVIEWABLE_EXTENSIONS = new Set(['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'txt']);

function isBrowserPreviewable(filename) {
  const ext = (filename || '').split('.').pop().toLowerCase();
  return BROWSER_PREVIEWABLE_EXTENSIONS.has(ext);
}

const MIME_BY_EXT = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  txt: 'text/plain',
};

export function downloadFile(blob, filename) {
  const ext = (filename || '').split('.').pop().toLowerCase();
  const mimeType = MIME_BY_EXT[ext] || blob.type || 'application/octet-stream';
  const namedFile = new File([blob], filename, { type: mimeType });
  const blobUrl = URL.createObjectURL(namedFile);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}

export function openFileInNewTab(blob, filename) {
  const ext = (filename || '').split('.').pop().toLowerCase();
  const mimeType = MIME_BY_EXT[ext] || blob.type || 'application/octet-stream';
  const namedFile = new File([blob], filename, { type: mimeType });
  const blobUrl = URL.createObjectURL(namedFile);

  if (!isBrowserPreviewable(filename)) {
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    return;
  }

  const newTab = window.open(blobUrl, '_blank');
  if (!newTab) {
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    return;
  }
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}

const usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatCurrency(value) {
  return value === null || value === undefined ? '' : usdFormatter.format(value);
}

/**
 * Displays a numeric grid value as USD. Used as a cellRenderer rather than a
 * valueFormatter because exportRowsToExcel applies valueFormatters, and money
 * must reach Excel as numbers to sort and sum correctly.
 */
export const currencyCellRenderer = ({ value }) => formatCurrency(value);
